module.exports = __webpack_public_path__ + "static/media/28.7b47bed6.jpg";